import { render, staticRenderFns } from "./VideoFrame.vue?vue&type=template&id=188ef47e"
import script from "./VideoFrame.vue?vue&type=script&lang=js"
export * from "./VideoFrame.vue?vue&type=script&lang=js"
import style0 from "./VideoFrame.vue?vue&type=style&index=0&id=188ef47e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports